import React, { useState } from "react"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"
import useWindowWidth from "../../../../hooks/useWindowWidth"

function EmployeeProfileComponent({
  employeePortrait,
  employeePortraitAltText,
  employeePortraitPosition,
  employeeName,
  employeeTitles,
  employeeStory,
  employeeStoryCutoff,
  readMoreButtonText,
  readLessButtonText,
}) {
  const windowWidth = useWindowWidth()
  const [showCutoff, setShowCutoff] = useState(false)

  return (
    //wrapper around this component is called .js--employee-profile-module
    <section className={`employee-profile-content ${SelectionFactoryHelper.getFromSelectionFactory(employeePortraitPosition)} w--wider`}>
      {employeePortrait ? (
        <img
          // eslint-disable-next-line
          epi-property-name="EmployeePortrait"
          className="employee-image"
          src={employeePortrait}
          alt={employeePortraitAltText || employeeName}
        ></img>
      ) : undefined}
      <h2
        // eslint-disable-next-line
        epi-property-name="EmployeeName"
        className="employee-name"
      >
        {employeeName || ""}
      </h2>
      {employeeTitles ? (
        <div className="titles-rich-text-wrapper">
          <div
            // eslint-disable-next-line
            epi-property-name="EmployeeTitles"
            className="rich-text"
            // eslint-disable-next-line
            epi-data-property-name=""
          >
            {ReactHtmlParser(employeeTitles)}
          </div>
        </div>
      ) : undefined}
      {employeeStory ? (
        <div className="story-rich-text-wrapper">
          <div
            // eslint-disable-next-line
            epi-property-name="EmployeeStory"
            className="rich-text"
          >
            {ReactHtmlParser(employeeStory)}
          </div>
        </div>
      ) : undefined}
      {employeeStoryCutoff ? (
        windowWidth >= 768 ? (
          <div className="story-cutoff-rich-text-wrapper">
            <div
              // eslint-disable-next-line
              epi-property-name="EmployeeStoryCutoff"
              className="rich-text"
            >
              {ReactHtmlParser(employeeStoryCutoff)}
            </div>
          </div>
        ) : (
          <div className="mobile-cutoff-section">
            {!showCutoff ? (
              <button
                // eslint-disable-next-line
                epi-property-name="ReadMoreButtonText"
                className="readmore"
                onClick={() => setShowCutoff(!showCutoff)}
              >
                {readMoreButtonText}
              </button>
            ) : undefined}
            {showCutoff ? (
              <div className="story-cutoff-rich-text-wrapper">
                <div className="rich-text">{ReactHtmlParser(employeeStoryCutoff)}</div>
                {showCutoff ? (
                  <button
                    // eslint-disable-next-line
                    epi-property-name="ReadLessButtonText"
                    className="readless"
                    onClick={() => setShowCutoff(!showCutoff)}
                  >
                    {readLessButtonText}
                  </button>
                ) : undefined}
              </div>
            ) : undefined}
          </div>
        )
      ) : undefined}
    </section>
  )
}

export default EmployeeProfileComponent
